import { useEffect, useRef } from "react";
import lottie from "lottie-web";

const LottiePlayer = ({ animationData }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData,
    });

    return () => anim.destroy();
  }, [animationData]);

  return (
    <div
      ref={containerRef}
      style={{
        // width: "clamp(450px, 100vw, 1000px)",
        // height: "clamp(300px, 40dvh,900px)",
        width: "min(100vw, 1000px)",
        height: "min(50vh, 1000px)",
        // maxHeight: "50dvh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // overflow: "hidden",
      }}
    />
  );
};

export default LottiePlayer;
